import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import ClinicHistoryFull from './Components/ClinicHistoryFull';

const ClinicHistoryComplete = (props) => {
    return (<Container className="dashboard">
        <Row>
            <Col md={12}>
                <h3 className="page-title">Historia Clínica </h3>
            </Col>
        </Row>
        <Row>
            <ClinicHistoryFull data={props.location.state.data} />
        </Row>
    </Container>)
};

export default ClinicHistoryComplete;